<template>
	<figure>
		<div class="sparklist">      
	        <span class="sparkline">
	        	<span class="index" v-for="val in values" 
	        		  :style="`width:${barWidth}px; height:${barHeight}em;`">
	          		<span class="count" 
	          			  :style="`height:${val}%; background: ${barColor};`">
	          			{{val}}
	          		</span> 
	          	</span>
	        </span>		      
	    </div>
	</figure>
</template>

<script>
	export default {
      	props: ['values', 'color', 'barwidth', 'barheight'],
      	data() {
        	return {
        	};
      	},
      	computed: {
      		barColor() {
      			return this.color ? this.color : '#999';
      		},
      		barWidth() {
      			return this.barwidth ? this.barwidth : 2;
      		},
      		barHeight() {
      			return this.barheight ? this.barheight : 1;
      		}
      	}
    };
</script>

<style scoped>
	.sparklist {
	  overflow: visible;
	  width: 100%;
	  margin: 0;
	  padding: 0;
	}

	.sparkline { 
	  display: inline-block;
	  height: 1em;
	  margin: 0 0.5em;
	  transition: all .5s ease;
	}

	.sparkline .index { 
	  position: relative;
	  float: left; 
	  width: 2px; 
	  height: 2em; 
	}

	.sparkline .index .count { 
	  display: block; 
	  position: absolute; 
	  bottom: 0; 
	  left: 0; 
	  width: 100%; 
	  height: 0; 
	  background: #AAA;
	  font: 0/0 a;
	  text-shadow: none;
	  color: transparent;
	}

	/* LAYOUT STYLES */
	html, body {
	  height: 100%;
	}


	figcaption {
	  margin-top: 20px;
	}

	a {
	  font-size: 15px;
	  text-transform: uppercase;
	  text-decoration: none;
	  color: #aaa;
	  transition: color .3s ease;
	  
	  &:hover,
	  &:focus {
	    color: #333;
	  }
	}
</style>